export const ADD_DASHBOARDS = 'ADD_DASHBOARDS';
export const REMOVE_PUBLIC_DASHBOARD = 'REMOVE_PUBLIC_DASHBOARD';
export const REMOVE_DIRECT_ACCESS_DASHBOARDS = 'REMOVE_DIRECT_ACCESS_DASHBOARDS';
